export default "__VITE_ASSET__BtwpjYwu__"